import {
  GET_REGRAS_AVALIACAO,
  GET_REGRAS_AVALIACAO_SUCCESS,
  ADD_REGRAS_AVALIACAO,
  ADD_REGRAS_AVALIACAO_SUCCESS,
  UPDATE_REGRAS_AVALIACAO,
  UPDATE_REGRAS_AVALIACAO_SUCCESS,
  DELETE_REGRAS_AVALIACAO,
  DELETE_REGRAS_AVALIACAO_SUCCESS,
  BUSCA_REGRAS_AVALIACAO_EDICAO,
  BUSCA_REGRAS_AVALIACAO_EDICAO_SUCESSO,
  NOVO_REGRAS_AVALIACAO,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE,
  CANCELA_EDICAO,
  APLICA_FILTRO_REGRA_AVALIACAO
} from '../constants/ActionTypes';

export const onChangeFilterRegraAvaliacao = (e) => ({
  type: APLICA_FILTRO_REGRA_AVALIACAO,
  payload: e.target.value
});

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  };
};

export const cancelaEdicao = () => {
  return {
    type: CANCELA_EDICAO
  };
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showSuccessMessage = (message) => {
  return {
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
  };
};

export const showLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};

export const getRegrasAvaliacao = (filter) => {
  return {
    type: GET_REGRAS_AVALIACAO,
    payload: filter
  };
};

export const getRegrasAvaliacaoSuccess = (data) => {
  return {
    type: GET_REGRAS_AVALIACAO_SUCCESS,
    payload: data
  };
};

export const addRegrasAvaliacao = (data) => {
  return {
    type: ADD_REGRAS_AVALIACAO,
    payload: data
  };
};

export const addRegrasAvaliacaoSuccess = (data) => {
  return {
    type: ADD_REGRAS_AVALIACAO_SUCCESS,
    payload: data
  };
};

export const updateRegrasAvaliacao = (data) => {
  return {
    type: UPDATE_REGRAS_AVALIACAO,
    payload: data
  };
};

export const updateRegrasAvaliacaoSuccess = (data) => {
  return {
    type: UPDATE_REGRAS_AVALIACAO_SUCCESS,
    payload: data
  };
};

export const deleteRegrasAvaliacao = (id) => {
  return {
    type: DELETE_REGRAS_AVALIACAO,
    payload: id
  };
};

export const deleteRegrasAvaliacaoSuccess = (id) => {
  return {
    type: DELETE_REGRAS_AVALIACAO_SUCCESS,
    payload: id
  };
};

export const buscaRegrasAvaliacaoEdicao = (id) => {
  return {
    type: BUSCA_REGRAS_AVALIACAO_EDICAO,
    payload: id
  };
};

export const buscaRegrasAvaliacaoEdicaoSuccess = (data) => {
  return {
    type: BUSCA_REGRAS_AVALIACAO_EDICAO_SUCESSO,
    payload: data
  };
};

export const novoRegrasAvaliacao = () => {
  return {
    type: NOVO_REGRAS_AVALIACAO
  };
};
